var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"layout/padding:right:page:0.5 layout/absolute layout/right:0% layout/top:0% link/cursor",on:{"click":function($event){return _vm.$emit('close')}}},[_c('Icon',{attrs:{"icon-name":"icon__x--24--stroke.svg","class-name":"\n        $color/black\n        $typography/size:large\n        typography/icon\n      "}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }